export const race = {
    "13": "#67B1E4",
    "12": "#8B3F0F",
    "11": "#F5903D",
    "10": "#D16194",
    "9": "#88BF40",
    "8": "#844B9B",
    "7": "#FCE59C",
    "6": "#000000",
    "5": "#FBFBFB",
    "4": "#00A850",
    "3": "#F14643",
    "2": "#009AD9",
    "1": "#FFE62A",
};
